import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import Config from "config";
const SouscriptionsEnCours = ({ listData }) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  const style = { fontFamily: "sans-serif" };
  const backUrl = Config.backOffice.url;
  return (
    <>
      {listData.allowed ? (
        <>
          <CardTitle style={{ color: "#555b21" }} className="mb-2">
            {listData.title}
          </CardTitle>
          <Col>
            <Card className="mini-stats-wid">
              <CardBody>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead className="nowrap-header">
                      <tr>
                        <th key="link_to_record"></th>
                        {listData.header.map((item, index) => (
                          <th key={index} className="text-nowrap">
                            {item}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {listData.data.length > 0 ? (
                        listData.data.map((item) => (
                          <tr key={item.id}>
                            <>
                              <td>
                                <Link
                                  className="btn btn-sm btn-soft-primary"
                                  to={`${backUrl}/reservations_en_cours/${item.id}`}
                                >
                                  <i className="mdi mdi-eye-outline"></i>
                                </Link>
                              </td>
                              <td>{item.nom_investisseur}</td>
                              {item?.cgp ? <td>{item.cgp}</td> : null}

                              <td>
                                {item?.statut ==
                                "En attente de règlement et/ou des pièces justificatives" ? (
                                  <>
                                    <span
                                      className="bg-success badge bg-secondary"
                                      style={{
                                        fontSize: "100%",
                                        whiteSpace: "break-spaces",
                                      }}
                                    >
                                      {item.statut}
                                    </span>
                                  </>
                                ) : item.statut == "En cours de signature" ? (
                                  <>
                                    <span
                                      className="bg-info badge bg-secondary"
                                      style={{ fontSize: "100%" }}
                                    >
                                      {item.statut}
                                    </span>
                                  </>
                                ) : item.statut == "En attente de signature" ? (
                                  <>
                                    <span
                                      className="bg-warning badge bg-secondary"
                                      style={{ fontSize: "100%" }}
                                    >
                                      {item.statut}
                                    </span>
                                  </>
                                ) : null}
                              </td>
                            </>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={listData.header.length + 1}>
                            Aucune donnée disponible
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default SouscriptionsEnCours;
